export const fr = {
  nonprofitApp: {
    nav: {
      myEvents: 'Mes événements',
      donations: 'Dons',
      nonprofitSettings: "Paramètres de l'organisme",
      employees: 'Employés',
    },
    donations: {
      title: 'Dons',
      searchPlaceholder: 'Rechercher des dons...',
      columns: {
        donor: 'Donateur',
        amount: 'Montant',
        receipt: 'Reçu #',
        status: 'Statut',
        date: 'Date',
      },
      empty: {
        title: 'Aucun don',
        subtitle: "Vous n'avez pas encore reçu de dons.",
      },
    },
    dashboard: {
      description: 'Voici votre tableau de bord où vous pouvez gérer vos événements et voir votre impact.',
      checklist: {
        title: 'Complétez le profil de votre organisme',
        subtitle: 'Aidez les donateurs et les bénévoles à en savoir plus sur votre organisme.',
        logo: 'Télécharger un logo',
        shortDescription: 'Ajouter un résumé court',
        longDescription: 'Ajouter une description détaillée',
        stripe: 'Connecter Stripe pour accepter les dons',
      },
      stats: {
        activeEvents: 'Événements actifs',
        uniqueVolunteers: 'Bénévoles uniques',
        totalSignUps: 'Inscriptions totales',
        hoursVolunteered: 'Heures de bénévolat',
      },
    },
    events: {
      title: 'Mes événements',
      searchPlaceholder: 'Rechercher des événements...',
      columns: {
        eventName: "Nom de l'événement",
        company: 'Entreprise',
        date: 'Date',
        location: 'Lieu',
        attendance: 'Présence',
        status: 'Statut',
      },
      statuses: {
        cancelled: 'Annulé',
        published: 'Publié',
        draft: 'Brouillon',
      },
      virtual: 'Virtuel',
      empty: {
        title: 'Aucun événement',
        subtitle: "Vous n'avez pas encore d'événements.",
      },
    },
    settings: {
      title: "Paramètres de l'organisme",
      alerts: {
        stripeConnected: 'Compte Stripe connecté\u00a0!',
        stripeError: 'Impossible de vérifier le compte Stripe. Veuillez réessayer.',
        stripeOnboardingError: "Échec du démarrage de l'intégration Stripe. Veuillez réessayer.",
        saved: 'Paramètres mis à jour avec succès',
      },
      sections: {
        generalInformation: 'Informations générales',
        longDescription: 'Description détaillée',
        location: 'Emplacement',
        logo: 'Logo',
        badge: 'Insigne',
        donations: 'Dons',
      },
      fields: {
        website: { label: 'Site web', placeholder: 'https://votre-organisme.org' },
        shortSummary: {
          label: 'Résumé court',
          placeholder: 'Parlez-nous de votre organisme...',
          hint: "1-2 phrases résumant l'objectif ou la mission de votre organisme.",
        },
        addressSearch: {
          label: "Recherche d'adresse",
          placeholder: 'Recherchez votre adresse...',
          hint: 'La sélection d\'une adresse remplira automatiquement les champs ci-dessous.',
        },
        addressLine: { label: 'Adresse', placeholder: '123 rue Principale' },
        city: { label: 'Ville', placeholder: 'Ville' },
        provinceState: { label: 'Province / État', placeholder: 'Province / État' },
        postalZip: { label: 'Code postal', placeholder: 'Code postal' },
        country: { label: 'Pays', hint: "Le pays ne peut pas être modifié après l'approbation." },
        logo: { hint: 'Télécharger un logo pour {{name}}' },
        badge: { hint: 'Télécharger un insigne pour {{name}}' },
      },
      stripe: {
        connected: '✓ Connecté et acceptant les dons',
        connectedHint: 'Votre compte Stripe est entièrement configuré. Les donateurs verront un bouton « Faire un don » sur votre profil.',
        incomplete: '⚠ Intégration incomplète',
        incompleteHint: "Vous avez commencé l'intégration Stripe mais ne l'avez pas terminée. Cliquez ci-dessous pour continuer.",
        notConnected: 'Non connecté',
        notConnectedHint: 'Connectez un compte Stripe pour activer les dons sur votre profil. Les fonds vous sont versés directement — Purposely prélève une petite commission.',
        continueOnboarding: "Continuer l'intégration Stripe",
        connect: 'Connecter à Stripe',
        loading: 'Chargement…',
      },
    },
    employees: {
      title: 'Gérer les employés',
      searchPlaceholder: 'Rechercher des employés...',
      unsavedChanges: '{{count}} modification(s) non enregistrée(s)',
      discard: 'Annuler',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      columns: {
        name: 'Nom',
        email: 'Courriel',
        isActive: 'Actif',
        isAdmin: 'Administrateur',
        joinedAt: 'Inscrit le',
      },
      empty: {
        title: 'Aucun employé',
        subtitle: "Cet organisme n'a pas encore d'employés.",
      },
    },
    accountSettings: {
      nav: {
        profile: 'Profil',
        password: 'Mot de passe',
        notifications: 'Notifications',
      },
      profile: {
        title: 'Profil',
        subtitle: 'Mettez à jour vos informations de profil.',
        sectionTitle: 'Photo de profil',
        sectionDescription: 'Cette photo est visible par les autres sur la plateforme.',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        saveButton: 'Enregistrer les modifications',
        saved: 'Profil mis à jour.',
      },
      notifications: {
        title: 'Notifications',
        comingSoon: 'Les préférences de notification arrivent bientôt.',
      },
    },
  },
}
